import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/baseNumeric.scss';
import { Typography } from '../../../Typography/Typography';
import { TypographyLevel } from '../../../Typography/TypographyLevel';
export const NumericPrefix = ({ prefix }) => {
    return (_jsx(Typography, { className: "numeric-prefix", level: TypographyLevel.BodySm, noWrap: true, children: prefix }));
};
